// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_Zy","alignRight":"e__y","alignLeft":"e_0y","item":"e_1y","icon":"e_2y","soft":"e_3y"};